'use client';

import { useEffect } from 'react';
import { usePathname, useRouter } from 'next/navigation';
import { useAuthStore } from '@/features/auth';
import { useFirstRunState } from '../model/first-run.query';
import { useFirstRunSession } from '../model/first-run.store';

export const FIRST_RUN_PATH = '/start';

// Screens the wizard must never pull a user away from. The OAuth consent
// screen holds a one-shot authorize request from another app; leaving it for
// /start strands that app's connection flow.
const EXEMPT_PATHS = ['/connect'];

/**
 * Sends an account the server marks as "no design started yet" to the wizard,
 * once per app session. After the wizard was presented (and left, by any
 * exit) the gate stays quiet until the next session, so it never traps the
 * user or fights other navigation.
 */
export function FirstRunGate() {
  const router = useRouter();
  const pathname = usePathname();
  const isReady = useAuthStore(
    (s) => s.isInitialized && s.isAuthenticated && !s.pendingEmailVerification
  );
  const presented = useFirstRunSession((s) => s.presentedThisSession);
  const state = useFirstRunState(isReady);

  useEffect(() => {
    if (
      !isReady ||
      presented ||
      pathname === FIRST_RUN_PATH ||
      EXEMPT_PATHS.includes(pathname)
    )
      return;
    if (state?.should_show === true) {
      router.replace(FIRST_RUN_PATH);
    }
  }, [isReady, presented, pathname, state, router]);

  return null;
}
